export const CREATE_SURVEY = 'CREATE_SURVEY';
export const CREATE_SURVEY_SUCCESS = 'CREATE_SURVEY_SUCCESS';
export const DELETE_SURVEY = 'DELETE_SURVEY';
export const DELETE_SURVEY_SUCCESS = 'DELETE_SURVEY_SUCCESS';
export const GET_GROUP_SURVEYS = 'GET_GROUP_SURVEYS';
export const GET_GROUP_SURVEYS_SUCCESS = 'GET_GROUP_SURVEYS_SUCCESS';
export const STOP_SURVEY = 'STOP_SURVEY';
export const VIEW_SURVEYS = 'VIEW_SURVEYS';
